import React from 'react';
import MedicalReportDetailLatamForm from './MedicalReportDetailLatamForm';
import { FormValues } from '../../Modules/MagicForm/Interfaces/FormValues';

interface MedicalReportDetailLatamProps {
	onSuccess?: (values: FormValues) => void;
	customSuccess?: (values: FormValues) => void;
	defaultData?: any;
	patientId: string;
	workplaceId: string;
	loggedUserId: string;
	disableSubmit?: boolean;
}

const MedicalReportDetailLatam: React.FC<MedicalReportDetailLatamProps> = ({
	onSuccess,
	defaultData,
	customSuccess,
	disableSubmit,
}) => {
	return (
		<MedicalReportDetailLatamForm
			onSubmit={customSuccess ? customSuccess : onSuccess}
			defaultData={defaultData}
			disableSubmit={disableSubmit}
		/>
	);
};

export default MedicalReportDetailLatam;
